import {Bindings} from "data/constants/bindings";
import type {ILocalizationStore} from "data/stores/localization/localization.store";
import type {ITutorialStep, ITutorialStore} from "data/stores/tutorial/tutorial.store";
import {ViewController} from "data/types/structure";
import {inject, injectable} from "inversify";
import {action, makeAutoObservable} from "mobx";

export interface ITutorialSliderController extends ViewController {
	get i18n(): ILocalizationStore;

	get steps(): ITutorialStep[];

	get currentStep(): number;
	goToStep: (currentSlide: number, nextSlide: number) => void;
}

@injectable()
export class TutorialSliderController implements ITutorialSliderController {
	constructor(
		@inject(Bindings.LocalizationStore) public readonly i18n: ILocalizationStore,
		@inject(Bindings.TutorialStore) private _tutorialStore: ITutorialStore
	) {
		makeAutoObservable(this);
	}
	@action
	public goToStep = (currentSlide: number, nextSlide: number): void => {
		this._tutorialStore.updateStep(nextSlide + 1);
	};

	// - 1 is fix for first step
	get currentStep(): number {
		return this._tutorialStore.currentStep - 1;
	}

	get steps(): ITutorialStep[] {
		return this._tutorialStore.steps;
	}

	dispose(): void {
		return;
	}

	init(param: void): void {
		return;
	}

	onChange(param: void): void {
		return;
	}
}
